import { L } from "@/asdcom/BaseComponent";

declare global {
  interface WizardMeta extends RouterMeta {
    prevRouteName?: string,
    nextRouteName?: string,
  }
}

export const ClaimSummary = {
  path: "",
  name: "ClaimSummary",
  permission: "Pages.Tenant.StaffUser",
  meta: {
    title: "ClaimSummary",
  },
  component: () => System.import("views/vcponlineok/staff-user/claim-view/claim-summary-view.vue")
}
export const VpBox = {
  path: "v-postal-box",
  name: "VpBox",
  permission: "Pages.Tenant.StaffUser",
  meta: {
    title: "VpBox",
  },
  component: () => System.import("views/vcponlineok/staff-user/claim-view/claim-vpbox-view.vue"),
}
export const UpdateRequests = {
  path: "update-requests/:id?",
  name: "UpdateRequests",
  permission: "Pages.Tenant.StaffUser",
  meta: {
    title: "UpdateRequests",
  },
  component: () => System.import("views/vcponlineok/staff-user/claim-view/claim-update-requests-view.vue"),
}
export const ClaimLog = {
  path: "log/:id?:reminder?",
  name: "ClaimLog",
  permission: "Pages.Tenant.StaffUser",
  meta: {
    title: "ClaimLog",
  },
  component: () => System.import("views/vcponlineok/staff-user/claim-view/claim-log-view.vue"),
}
export const Messages = {
  path: "messages/:id?:new?",
  name: "Messages",
  permission: "Pages.Tenant.StaffUser",
  meta: {
    title: "Messages",
  },
  component: () => System.import("views/vcponlineok/staff-user/claim-view/claim-messages-view.vue"),
}
export const AssignClaim = {
  path: "assign",
  name: "AssignClaim",
  permission: "Pages.Tenant.StaffAdminUser",
  meta: {
    title: "AssignClaim",
  },
  component: () => System.import("views/vcponlineok/staff-user/claim-view/claim-assign.vue"),
}
export const ChangeStatus = {
  path: "change-status",
  name: "ChangeStatus",
  permission: "Pages.Tenant.StaffUser",
  meta: {
    title: "ChangeStatus"
  },
  component: () => System.import("views/vcponlineok/staff-user/claim-view/change-status.vue")
}

export const ClaimTabs: Array<any> = [
  ClaimSummary,
  VpBox,
  UpdateRequests,
  ClaimLog,
  AssignClaim,
  ChangeStatus,
  Messages
]

export const Claim = [
  {
    path: "claim/:claimNumber/",
    // name: "Claim",
    permission: "Pages.Tenant.StaffUser",
    meta: {
      title: "Claim",
    },
    component: () => System.import("views/vcponlineok/staff-user/claim-view/claim-view.vue"),
    children: ClaimTabs
  }
]

export const staffUserRouters = [
  {
    path: "/staff-user/",
    name: "StaffUser",
    // component: () => System.import("src/views/vcponlineok/staff-user/staff-user-view.vue"),
    component: () => System.import("views/vcponlineok/staff-user/page-template.vue"),
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        permission: "Pages.Tenant.StaffUser",
        meta: { title: "Dashboard" },
        component: () => System.import("views/vcponlineok/staff-user/dashboard.vue"),
      },
      {
        path: "settings",
        name: "settings",
        permission: "Pages.Tenant.StaffUser",
        meta: { title: "Settings" },
        component: () => System.import("views/vcponlineok/staff-user/settings-view.vue"),
      },
      {
        path: "claim-tasks",
        name: "ClaimTasks",
        permission: "Pages.Tenant.StaffUser",
        meta: { title: "ClaimTasks" },
        component: () => System.import("views/vcponlineok/staff-user/claim-tasks.vue"),
      },
      {
        path: "applicant-requests/:id?",
        name: "ApplicantRequests",
        permission: "Pages.Tenant.StaffAdminUser",
        meta: { title: "ApplicantRequests" },
        component: () => System.import("views/vcponlineok/staff-user/applicant-requests-view.vue"),
      },
      {
        path: "reminders",
        name: "Reminders",
        permission: "Pages.Tenant.StaffUser",
        meta: { title: "Reminders" },
        component: () => System.import("views/vcponlineok/staff-user/reminders-view.vue"),
      },
      {
        path: "configuration",
        name: "Configuration",
        permission: "Pages.Tenant.StaffUser",
        meta: { title: "Configuration" },
        component: () => System.import("views/vcponlineok/staff-user/configuration-view.vue"),
      },
      {
        path: "notifications",
        name: "Notifications",
        permission: "",
        meta: { title: "Notifications" },
        component: () => System.import("views/vcponlineok/staff-user/notifications-view.vue"),
      },
      {
        path: "applicants",
        name: "ApplicantUsers",
        permission: "Pages.Tenant.StaffAdminUser",
        meta: { title: "ApplicantUsers" },
        component: () => System.import("views/vcponlineok/staff-user/applicants/applicant-users-view.vue"),
      },
      ...Claim,
    ],
  },
]



